import { useLocation, useNavigate } from 'react-router-dom';

import { useStateContext } from '../../contexts/ContextProvider';
import { messagerieMenageOuverte } from '../../domain/menage/messagerieMenage';
import { usePermissions } from '../../contexts/PermissionContext';
import { useFilsMenage } from '../api/useMessagesMenage';
import { t } from '../i18n/langue';

import Button from './Button';

/**
 * Q15 : un message urgent non lu de la messagerie ménage reste en rouge en haut de
 * TOUS les écrans jusqu'à ce qu'on l'ouvre. Rien quand la messagerie de l'hôtel
 * (ou son module ménage) est éteinte, ni sur le fil lui-même.
 */
export default function BandeauUrgent() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { currentFacility } = useStateContext();
    const { hasPermission } = usePermissions();
    const actif = messagerieMenageOuverte(currentFacility) && hasPermission('housekeeping.view');
    const { data } = useFilsMenage(currentFacility?.id ?? null, actif);

    const urgent = data?.threads.find((fil) => fil.has_unread_urgent);
    if (!actif || !urgent || pathname === `/hk-messages/${urgent.id}`) return null;

    return (
        <div role="alert" className="flex items-center justify-between gap-3 bg-alert-text-color px-4 py-2">
            {/* Pas de `Text` : ses tons ne prévoient pas le blanc sur rouge. */}
            <span className="font-semibold text-white">🔴 {t('messagesMenage.urgent.bandeau')}</span>
            <Button libelle={t('messagesMenage.urgent.ouvrir')} variante="secondaire" onPress={() => navigate(`/hk-messages/${urgent.id}`)} />
        </div>
    );
}
